import * as XLSX from 'xlsx';

const exportToExcel = (
   exportData,
  pricingSchema,
  selectedFields
) => {

  const worksheetData = exportData.flatMap((item) => {

    const commonData = {
      'Price List Item ID':
        item?.price_list_item_id || '',

      'Item Name':
        item?.product_name || '',

      'Item Price':
        item?.mrp || '',

      'SKU':
        item?.SKU || '',

      'GST Included':
        item?.gst_included || '',

      'HSN Code':
        item?.HSN_Code || '',

      'Type':
        pricingSchema || '',
    };

    // UNIT PRICING
    if (pricingSchema === 'Unit') {

      const unitData = {
        ...commonData,

        'Custom Rate':
          item?.pricing?.custom_rate || '',

        'Discount':
          item?.pricing?.discount || '',

        'Margin Rate':
          item?.pricing?.margin_rate || '',
      };

      // FILTER ONLY SELECTED FIELDS
      const filteredData = {};

      selectedFields.forEach((field) => {
        filteredData[field] = unitData[field];
      });

      return [filteredData];
    }

    // VOLUME PRICING
    else if (pricingSchema === 'Volume') {

      return item?.pricing?.map((volumeItem) => {

        const volumeData = {
          ...commonData,

          'Start Quantity':
            volumeItem?.start_quantity || '',

          'End Quantity':
            volumeItem?.end_quantity || '',

          'Custom Rate':
            volumeItem?.custom_rate || '',

          'Discount':
            volumeItem?.discount || '',

          'Margin Rate':
            volumeItem?.margin_rate || '',
        };

        // FILTER ONLY SELECTED FIELDS
        const filteredData = {};

        selectedFields.forEach((field) => {
          filteredData[field] = volumeData[field];
        });

        return filteredData;
      });
    }

    return [];
  });

  // CREATE WORKSHEET
  const worksheet = XLSX.utils.json_to_sheet(
    worksheetData
  );

  // DYNAMIC COLUMN WIDTHS
  worksheet['!cols'] = selectedFields.map(() => ({
    wch: 25
  }));

  // CREATE WORKBOOK
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    'Pricelist Product Rates'
  );

  // OPTIONAL STYLING FOR ITEM NAME COLUMN
  const itemNameIndex =
    selectedFields.indexOf('Item Name');

  if (itemNameIndex !== -1) {

    const range = XLSX.utils.decode_range(
      worksheet['!ref']
    );

    for (
      let R = range.s.r + 1;
      R <= range.e.r;
      ++R
    ) {

      const address = XLSX.utils.encode_cell({
        c: itemNameIndex,
        r: R
      });

      if (!worksheet[address]) continue;

      if (!worksheet[address].s) {
        worksheet[address].s = {};
      }

      worksheet[address].s.font = {
        color: { rgb: '0000FF' }
      };
    }
  }

  // DOWNLOAD EXCEL FILE
  XLSX.writeFile(
    workbook,
    'Pricelist_Product_Rates.xlsx'
  );
};

export { exportToExcel };